import { useCallback } from 'react';

import { useParams } from 'react-router-dom';

import {
  PrimaryDocumentOwner,
  hasDocumentId,
  primaryDocumentFileUrl,
} from '@/features/actsAndDocuments/primaryDocumentFiles';

// The file url of a stored document of the primary document, in the page's organization (GSB-8069). Null for a
// document without an id, and while the page has neither the organization nor the primary document.
export const usePrimaryDocumentFileUrl = ({
  kind,
  id,
}: PrimaryDocumentOwner) => {
  const { contextOrganizationId } = useParams<{
    contextOrganizationId: string;
  }>();

  // Keyed by the owner's kind and id, not the object: callers pass a new one on every render.
  return useCallback(
    (documentId: string | null | undefined) =>
      contextOrganizationId && id && hasDocumentId(documentId)
        ? primaryDocumentFileUrl({ kind, id }, documentId)
        : null,
    [contextOrganizationId, kind, id],
  );
};
